import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgId = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M21 3H3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2ZM3 5h18v14H3V5Z" />
      <path d="M8.5 7.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm0 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z" />
      <path d="M8.5 11.5a4 4 0 0 1 4 4 1 1 0 0 1-1.993.117L10.5 15.5a2 2 0 0 0-4 0 1 1 0 0 1-2 0 4 4 0 0 1 4-4ZM18 9a1 1 0 0 1 .117 1.993L18 11h-4a1 1 0 0 1-.117-1.993L14 9h4ZM18 13a1 1 0 0 1 .117 1.993L18 15h-3a1 1 0 0 1-.117-1.993L15 13h3Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgId)
const Memo = memo(ForwardRef)
export default Memo
